import React from "react";

import { ReactComponent as PactoBrasilImage } from "assets/svgs/pacto-brasil-logo.svg";
import { ReactComponent as SeloWOBImage } from "assets/svgs/wob-logo.svg";
import { ReactComponent as UNGlobalImage } from "assets/svgs/un-global-compact-logo.svg";
import { ReactComponent as MovimentoElasImage } from "assets/svgs/movimento-elas-logo.svg";
import { ReactComponent as MovimentoTransparenciaImage } from "assets/svgs/movimento-transparencia-logo.svg";

import * as S from "./SectionCertificate.Style";

const certificateList = [
  {
    id: 1,
    image: PactoBrasilImage,
    imageAlt:
      "Selo do programa “Pacto Brasil pela Integridade Empresarial” da CGU, com a inscrição “empresa participante” em destaque sobre fundo azul.",
    label: (
      <>
        Pacto Brasil <br /> pela integridade
      </>
    ),
  },
  {
    id: 2,
    image: SeloWOBImage,
    imageAlt:
      "Logotipo circular da WOB com sobreposição de círculos em tons de laranja, amarelo e cinza, e as letras “WOB” em branco no centro.",
    label: (
      <>
        Selo WOB
        <br /> (Women on Board)
      </>
    ),
  },
  {
    id: 3,
    image: UNGlobalImage,
    imageAlt:
      "Logotipo do Pacto Global da ONU com globo azul cercado por ramos de oliveira e a inscrição “UN Global Compact – Rede Brasil”",
    label: (
      <>
        UN Global Compact <br /> Empresa signatária
      </>
    ),
  },
  {
    id: 4,
    image: MovimentoElasImage,
    imageAlt: "Logotipo do Movimento Elas",
    className: "mobile-label-hidden",
    label: (
      <>
        Movimento <br />
        Elas Lideram 2030
      </>
    ),
  },
  {
    id: 5,
    image: MovimentoTransparenciaImage,
    imageAlt: "Logotipo do Movimento Elas",
    className: "mobile-label-hidden",
    label: (
      <>
        Movimento <br />
        Transparência 100%
      </>
    ),
  },
];

const SectionCertificate = () => {
  return (
    <div className="container">
      <S.SectionCertificateContainer>
        {certificateList.map((certificateItem) => (
          <S.SectionCertificateItem key={certificateItem.id}>
            <certificateItem.image />

            <S.SectionCertificateItemText className={certificateItem.className}>
              {certificateItem.label}
            </S.SectionCertificateItemText>
          </S.SectionCertificateItem>
        ))}
      </S.SectionCertificateContainer>
    </div>
  );
};

export default SectionCertificate;
